/** @jsx jsx */
import { jsx } from '@emotion/core';
import React, { useEffect, Fragment } from 'react';
import { BaseTemplate, Button, Card, Icons, PageHead, PageState } from '@myob/myob-widgets';
import { useLocation } from 'react-router-dom';
import { EPage, getPageContentMapping, PageContentDetails } from './pageContent';
import { trackClickInErrorPage, trackViewInErrorPage } from 'pages/ErrorPages/helper';
import { openInNewTab } from 'helpers/tools';
import { useRegionConfig } from 'hooks/useRegionConfig/useRegionConfig';
import NavigationBar from 'components/NavigationBar';

export interface LocationStateInUnauthorizedPage {
    pageName: EPage;
}

export const Unauthorized: React.FC = () => {
    const { state } = useLocation<LocationStateInUnauthorizedPage>();
    const pageName: EPage = state?.pageName || EPage.Unauthorized;
    const { pageHeading, pageDescription, contentHeading } = getPageContentMapping()[pageName] as PageContentDetails;
    const { HELP_LINK } = useRegionConfig();

    useEffect(() => {
        trackViewInErrorPage('unauthorized', pageName);
    }, [pageName]);

    const handleClick = () => {
        trackClickInErrorPage('support', EPage.Unauthorized);
        openInNewTab(HELP_LINK);
    };
    return (
        <Fragment>
            <NavigationBar />
            <BaseTemplate>
                {pageHeading && <PageHead title={pageHeading} />}
                {pageDescription && <p>{pageDescription}</p>}
                <Card>
                    <PageState
                        title={contentHeading}
                        description="Contact the primary contact of this account to get authorised account access. If you need help, get in touch with our support team."
                        actions={[
                            <Button key={1} type="link" icon={<Icons.Help />} onClick={handleClick}>
                                Contact our support team
                            </Button>,
                        ]}
                        image={
                            <img
                                src="https://feelix-assets.s3-ap-southeast-2.amazonaws.com/page-state/empty-state/no-results-found.svg"
                                alt="no results found"
                            />
                        }
                    />
                </Card>
            </BaseTemplate>
        </Fragment>
    );
};

export default Unauthorized;
